module.exports = __webpack_public_path__ + "img/logo-m1pay.0a5f1b90.svg";